export const actionTypes: any = {
  // get Rivew Status
  GET_REVIEW_STATUS_START: 'GET_REVIEW_STATUS_START',
  GET_REVIEW_STATUS_SUCCESS: 'GET_REVIEW_STATUS_SUCCESS',
  GET_REVIEW_STATUS_FINISH: 'GET_REVIEW_STATUS_FINISH',
}
